import React from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import DeleteIcon from "@material-ui/icons/Delete";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import KeyboardVoiceIcon from "@material-ui/icons/KeyboardVoice";
import Icon from "@material-ui/core/Icon";
import SaveIcon from "@material-ui/icons/Save";
import IconButton from "@material-ui/core/IconButton";
import Link from "@material-ui/core/Link";
import MyButton from "../MyButton";

class FileAttachControl extends React.Component {
  constructor(props) {
    super(props);
    this.showFile = this.showFile.bind(this);
    this.state = {};
  }
  //khi load component: load cac danh muc can thiet
  componentDidMount() {}
  static getDerivedStateFromProps(props, state) {
    return state;
  }
  showFile = (fileID) => {
    //console.log(fileID);
  };
  render() {
    const { classes, theme } = this.props;
    return (
      <>
        <Link
          className={classes.fileLink}
          href="/test.aspx"
          target="_blank"
          onClick={this.showFile(this.props.file.FileID)}
          variant="body2"
        >
          {this.props.file.FileName}
        </Link>
        <IconButton color="secondary"
          onClick={() => {
            this.props.requestDelete(this.props.file.FileID);
          }}
        >
          <DeleteIcon />
        </IconButton>
        </>
    );
  }
}
const styles = (theme) => ({
  button: {
    margin: theme.spacing(1),
  },
  fileLink: {
    flexGrow: 1,
  },
});
export default withStyles(styles, { withTheme: true })(FileAttachControl);
